import styled from 'styled-components';
import { Dialog } from '@oneaudi/unified-web-alpha-components';
import {
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-alpha-common-v2';
import { device } from '../../app/styles/devices';
import { ALPHA_THEME } from '../ThemeProvider/alphaTheme';

export const StyledDialog = styled(Dialog)`
  color: ${ALPHA_THEME.foregroundNeutral100};
`;

export const TitleWrapper = styled.div`
  margin-top: ${SYS_SPACE_FIXED_300};
  margin-bottom: ${SYS_SPACE_FIXED_300};
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
`;

export const MSRP = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${SYS_SPACE_FIXED_100};
  margin-top: ${SYS_SPACE_FIXED_100};
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;

export const MainTextWrapper = styled.div`
  margin-top: ${SYS_SPACE_FIXED_300};
  margin-bottom: ${SYS_SPACE_FIXED_200};
  max-height: 160px;
  overflow-y: auto;
  white-space: pre-wrap;
  @media ${device.tablet} {
    max-height: 280px;
  }
`;

export const PaymentsWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ExpirationDateWrapper = styled.div`
  color: ${ALPHA_THEME.foregroundNeutral300};
`;

export const CTAsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
  margin-top: ${SYS_SPACE_FIXED_300};
  @media ${device.tablet} {
    flex-direction: row;
    margin-top: ${SYS_SPACE_FIXED_300};
  }
`;
